module.exports = __webpack_public_path__ + "img/public/siteImages/minibus.svg?b3f213a8";